
export default function ContentSection() {
  const topics = [
    {
      id: 1,
      title: 'Visa du lịch Mỹ',
      subtitle: 'Điều kiện • Hồ sơ • Mẹo phỏng vấn',
      description: 'Hướng dẫn chi tiết về quy trình xin visa du lịch Mỹ (B1/B2), các loại giấy tờ cần thiết, cách chuẩn bị hồ sơ hoàn hảo và những mẹo quan trọng để vượt qua buổi phỏng vấn tại Đại sứ quán thành công.',
      icon: 'ri-passport-line',
      color: 'blue',
      bgGradient: 'from-blue-50 to-white',
      borderColor: 'border-blue-600',
      iconColor: 'text-blue-600',
      buttonColor: 'bg-blue-600 hover:bg-blue-700',
      fullWidth: true,
      badge: null
    },
    {
      id: 2,
      title: 'Kinh nghiệm thuê xe & lái xe tại Mỹ',
      subtitle: null,
      description: 'Tất cả những gì bạn cần biết về thuê xe tại Mỹ: các hãng xe uy tín, giá cả, bảo hiểm, luật giao thông, bằng lái quốc tế và những lưu ý quan trọng khi lái xe trên đất Mỹ.',
      icon: 'ri-car-line',
      color: 'orange',
      bgGradient: 'bg-white',
      borderColor: 'border-gray-200',
      iconColor: 'text-orange-500',
      buttonColor: 'bg-orange-500 hover:bg-orange-600',
      fullWidth: false,
      badge: null
    },
    {
      id: 3,
      title: 'Bảo hiểm du lịch',
      subtitle: null,
      description: 'Tầm quan trọng của bảo hiểm du lịch khi đến Mỹ, các loại bảo hiểm phù hợp, mức chi phí hợp lý và cách chọn gói bảo hiểm tốt nhất cho chuyến đi của bạn.',
      icon: 'ri-shield-check-line',
      color: 'green',
      bgGradient: 'bg-white',
      borderColor: 'border-gray-200',
      iconColor: 'text-green-500',
      buttonColor: 'bg-green-500 hover:bg-green-600',
      fullWidth: false,
      badge: null
    },
    {
      id: 4,
      title: 'Chi phí dự trù khi du lịch Mỹ',
      subtitle: null,
      description: 'Phân tích chi tiết các khoản chi phí: vé máy bay, khách sạn, ăn uống, di chuyển, tham quan và mua sắm. Giúp bạn lập kế hoạch ngân sách chính xác cho chuyến đi.',
      icon: 'ri-wallet-3-line',
      color: 'purple',
      bgGradient: 'bg-white',
      borderColor: 'border-gray-200',
      iconColor: 'text-purple-600',
      buttonColor: 'bg-purple-600 hover:bg-purple-700',
      fullWidth: false,
      badge: 'Quan trọng'
    },
    {
      id: 5,
      title: 'Mẹo tiết kiệm',
      subtitle: null,
      description: 'Những bí quyết giúp bạn tiết kiệm chi phí mà vẫn có trải nghiệm tuyệt vời: săn vé máy bay giá rẻ, khách sạn ưu đãi, ăn uống tiết kiệm và các chương trình giảm giá.',
      icon: 'ri-piggy-bank-line',
      color: 'pink',
      bgGradient: 'bg-white',
      borderColor: 'border-gray-200',
      iconColor: 'text-pink-500',
      buttonColor: 'bg-pink-500 hover:bg-pink-600',
      fullWidth: false,
      badge: null,
      tips: [
        'Đặt vé sớm 2-3 tháng trước',
        'Sử dụng thẻ tín dụng có hoàn tiền',
        'Tham gia chương trình khách hàng thân thiết'
      ]
    },
    {
      id: 6,
      title: 'Checklist chuẩn bị hành lý',
      subtitle: null,
      description: 'Danh sách đầy đủ những gì cần mang theo khi du lịch Mỹ: giấy tờ, quần áo, đồ dùng cá nhân, thuốc men và những vật dụng thiết yếu không thể thiếu.',
      icon: 'ri-luggage-cart-line',
      color: 'blue',
      bgGradient: 'bg-white',
      borderColor: 'border-gray-200',
      iconColor: 'text-blue-500',
      buttonColor: 'bg-blue-500 hover:bg-blue-600',
      fullWidth: false,
      badge: null,
      preview: [
        'Hộ chiếu & visa',
        'Vé máy bay & booking khách sạn',
        'Bảo hiểm du lịch',
        'Thẻ tín dụng quốc tế',
        'Thuốc men cá nhân'
      ]
    },
    {
      id: 7,
      title: 'Lưu ý khi đi cùng trẻ em / người già',
      subtitle: null,
      description: 'Những điều cần chuẩn bị và lưu ý đặc biệt khi du lịch Mỹ cùng trẻ nhỏ hoặc người cao tuổi: giấy tờ, sức khỏe, lịch trình phù hợp và các dịch vụ hỗ trợ.',
      icon: 'ri-parent-line',
      color: 'orange',
      bgGradient: 'bg-white',
      borderColor: 'border-gray-200',
      iconColor: 'text-orange-400',
      buttonColor: 'bg-orange-400 hover:bg-orange-500',
      fullWidth: true,
      badge: null
    }
  ];

  return (
    <div>
      {/* Introduction */}
      <div className="bg-white rounded-lg p-8 mb-8">
        <p className="text-base leading-relaxed text-gray-700">
          Chào mừng bạn đến với trang hướng dẫn toàn diện về <span className="bg-yellow-100 px-1">visa, thủ tục và kinh nghiệm du lịch Mỹ</span>. 
          Chúng tôi tổng hợp những thông tin thiết yếu, cập nhật và chính xác nhất để giúp bạn chuẩn bị chu đáo cho chuyến hành trình khám phá nước Mỹ. 
          Từ việc xin visa, lập kế hoạch chi tiêu đến những mẹo nhỏ giúp chuyến đi trở nên suôn sẻ và tiết kiệm hơn.
        </p>
      </div>

      {/* Topics Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {topics.map((topic) => (
          <div
            key={topic.id}
            onClick={() => {
              if (topic.id === 1) {
                window.REACT_APP_NAVIGATE('/visa-us-guide');
              } else if (topic.id === 2) {
                window.REACT_APP_NAVIGATE('/car-rental-guide');
              } else if (topic.id === 3) {
                window.REACT_APP_NAVIGATE('/travel-insurance-guide');
              } else if (topic.id === 4) {
                window.REACT_APP_NAVIGATE('/travel-budget');
              } else if (topic.id === 5) {
                window.REACT_APP_NAVIGATE('/money-saving-tips');
              }
            }}
            className={`${topic.fullWidth ? 'md:col-span-2' : ''} ${
              topic.bgGradient.includes('from') ? `bg-gradient-to-r ${topic.bgGradient}` : topic.bgGradient
            } border ${topic.borderColor} ${
              topic.id === 1 || topic.id === 2 || topic.id === 3 ? 'border-l-4' : ''
            } rounded-xl p-8 shadow-sm hover:shadow-lg transition-all duration-300 hover:-translate-y-1 ${
              topic.id === 1 || topic.id === 2 || topic.id === 3 || topic.id === 4 || topic.id === 5 ? 'cursor-pointer' : 'cursor-default'
            } relative`}
          >
            {topic.badge && (
              <div className="absolute top-4 right-4 bg-red-50 text-red-600 text-xs font-semibold px-3 py-1 rounded-full whitespace-nowrap">
                {topic.badge}
              </div>
            )}
            
            <div className={`w-12 h-12 flex items-center justify-center mb-4 ${topic.id === 1 ? 'w-14 h-14' : ''}`}>
              <i className={`${topic.icon} ${topic.iconColor} ${topic.id === 1 ? 'text-5xl' : 'text-4xl'}`}></i>
            </div>
            
            <h3 className={`${topic.id === 1 ? 'text-2xl' : 'text-xl'} font-bold text-gray-900 mb-2`}>
              {topic.title}
            </h3>
            
            {topic.subtitle && (
              <p className="text-sm text-gray-600 mb-3">{topic.subtitle}</p>
            )}
            
            <p className="text-sm leading-relaxed text-gray-600 mb-4">
              {topic.description}
            </p>

            {topic.tips && (
              <div className="mb-4 space-y-2">
                {topic.tips.map((tip, index) => (
                  <div key={index} className="flex items-start gap-2">
                    <i className="ri-checkbox-circle-fill text-pink-500 text-sm mt-0.5"></i>
                    <span className="text-sm text-gray-700">{tip}</span>
                  </div>
                ))}
              </div>
            )}

            {topic.preview && (
              <div className="mb-4 bg-gray-50 rounded-lg p-4">
                <div className="space-y-2">
                  {topic.preview.map((item, index) => (
                    <div key={index} className="flex items-center gap-2">
                      <i className="ri-check-line text-blue-500 text-sm"></i>
                      <span className="text-sm text-gray-700">{item}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}
            
            <div className={topic.fullWidth ? 'flex justify-end' : ''}>
              <button className={`${topic.buttonColor} text-white px-6 py-2.5 rounded-lg text-sm font-medium transition-all duration-200 hover:scale-105 whitespace-nowrap cursor-pointer`}>
                Đọc bài viết →
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
